/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
import React from 'react'

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation
} from 'react-router-dom'
import Error from './Components/Error'
import LoginPage from './Components/LoginPage'
import Signup from './Components/Signup'
import UploadDocuments from './Components/UploadDocuments'
import './Main.css'
import Mains from './Components/Main'
const authentication = {
  isAuthenticated: false,
  authenticate () {
    authentication.isAuthenticated = true
  },
  signOut (cb) {
    sessionStorage.clear()
    authentication.isAuthenticated = false
    setTimeout(cb, 100)
  }
}

function Main (props) {
  const history = useHistory()
  let location = useLocation()
  let { from } = location.state || { from: { pathname: '/' } }

  let logout = () => {
    authentication.signOut(() => {
      history.replace(from)
    })
  }
  let submit = () => {
    history.replace('/upload')
  }
  return (
    // eslint-disable-next-line react/prop-types
    <Mains onClick={logout} onSubmit={submit} incompleteApplicationId={parseInt(props.incompleteApplicationId)} token={props.token} history={history}/>
  )
}
function Upload (props) {
  const history = useHistory()
  let location = useLocation()
  let { from } = location.state || { from: { pathname: '/' } }
  let logout = () => {
    authentication.signOut(() => {
      history.replace(from)
    })
  }
  return (
    // eslint-disable-next-line react/prop-types
    <UploadDocuments onClick={logout} incompleteApplicationId={parseInt(props.incompleteApplicationId)} history={history}/>
  )
}
function ErrorPage () {
  let history = useHistory()
  return (
    <Error onClick={() => history.push('/')} />
  )
}

// eslint-disable-next-line react/prop-types
function PrivateRoute ({ children, ...rest }) {
  let token = sessionStorage.getItem('token')
  let userId = sessionStorage.getItem('id')
  let expiry = sessionStorage.getItem('expiry')
  let nowDate = new Date()
  if (expiry >= nowDate.toString() && token && userId) {
    return (
      <Route
        {...rest}
        render={() =>
          (children)
        }
      />
    )
  } else {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          (token && userId) ? (children) : (
            <Redirect
              to={{
                pathname: './login',
                state: { from: location }
              }}
              exact
            />
          )
        }
      />

    )
  }
}

export default class App extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      incompleteApplicationId: 0,
      token: 0,
      email: ''
    }
  }

  render () {
    const { incompleteApplicationId, token, email } = this.state
    return (
      <Router basename={'/ApplicationForm'}>
        <Switch>
          <Route path="/login"
            render={(props) => (
              <LoginPage {...props} onLogin={(email, id, token) => {
                this.setState({ incompleteApplicationId: id, token: token, email: email })
                authentication.authenticate()
              }}/>
            )}
          >
          </Route>
          <Route path="/signup"
            render={(props) => (
              <Signup {...props} onLogin={(email, id, token) => {
                this.setState({ incompleteApplicationId: id, token: token, email: email })
                authentication.authenticate()
              }}/>
            )}
          >
          </Route>

          <PrivateRoute path="/" exact>
            <Main incompleteApplicationId={ incompleteApplicationId} token={ token} email={ email}/>

          </PrivateRoute>
          <PrivateRoute path="/upload">
            <Upload
              incompleteApplicationId={ incompleteApplicationId}
              token={ token}
            />
          </PrivateRoute>
          <Route component={ErrorPage} />
        </Switch>
      </Router>
    )
  }
}
